// @flow
import styled, { type StyledComponent } from 'styled-components'

export default (styled.div`
  padding-bottom: 8px;
`: StyledComponent<Object, any, any>)
